import { Fab, Tooltip } from "@mui/material";
import AssistantIcon from "@mui/icons-material/Assistant";
import styles from "../styles";

const FloatingButton = ({ open, onClick }: { open: boolean; onClick: () => void }) => (
  <Tooltip title="Ask LoanWatch Pulse" placement="bottom">
    <Fab color="primary" sx={styles.fab(open)} size="small" onClick={onClick}>
      <AssistantIcon sx={styles.fabIcon(open)} />
    </Fab>
  </Tooltip>
);

export default FloatingButton;